import React from "react";
import { createPortal } from "react-dom";

const ErrorAlert = ({ message, onClose }) => {
	if (!message) return null; // Don't render if no message

	return createPortal(
		<div
			className="fixed left-1/2 transform -translate-x-1/2 w-11/12 max-w-sm 
                 bg-red-500 text-white px-4 py-3 rounded-lg shadow-lg flex justify-between 
                 items-center z-[99999]"
			style={{
				position: "fixed",
				bottom: "80px", // Increased height from bottom
				left: "50%",
				transform: "translateX(-50%)",
				width: "90%",
				maxWidth: "400px",
				backgroundColor: "#EF4444",
				color: "white",
				padding: "12px",
				borderRadius: "8px",
				boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
				zIndex: 99999, // Ensure it's on top
			}}
		>
			<span className="text-sm flex-1">{message}</span>
		</div>,
		document.body // Moves it outside of any parent container
	);
};

export default ErrorAlert;
